import React, { useState } from 'react';
// import mobileAppImage from './../assets/images/mobile-app.png'; 
import playStoreImage from './../assets/images/googleplay.webp'; // Replace with your actual image path
import appStoreImage from './../assets/images/appstore.webp'; // Replace with your actual image path
import { API_BASE_URL } from '../config/api';

function DownloadApp() {
    const playStoreLink = "https://play.google.com/store/apps/details?id=com.arttokri.app"; // Replace with your actual Play Store link
    const appStoreLink = "https://apps.apple.com/app/id6761808592"; // Replace with your actual App Store link

    const [modalOpen, setModalOpen] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleStoreClick = (e, storeType) => {
        e.preventDefault();
        setModalOpen(true);
        // You can store which store was clicked if needed
        // setSelectedStore(storeType);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!mobileNumber || mobileNumber.length < 10) {
            alert("Please enter a valid mobile number");
            return;
        }

        setIsSubmitting(true);

        // Here you can make an API call to save the user's mobile number
        try {
            const response = await fetch(
                `${API_BASE_URL}/server/website/user/notify-app-launch`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        mobile_number: mobileNumber
                    })
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Something went wrong");
            }

            // Simulate API call
            await new Promise(resolve => setTimeout(resolve, 1000));

            setSubmitted(true);

            // Reset form after 3 seconds and close modal
            setTimeout(() => {
                setModalOpen(false);
                setMobileNumber('');
                setSubmitted(false);
            }, 2000);

        } catch (error) {
            console.error("Error saving mobile number:", error);
            alert("Something went wrong. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setMobileNumber('');
        setSubmitted(false);
    };

    return (
        <>
            <section className="download-app-wrapper py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        {/* Left Side - Text Content */}
                        <div className="col-lg-10 col-md-12 mb-4 mb-lg-0 ">
                            <div className="app-content text-center text-lg-start ">
                                <h2 className="title mb-3 text-center" style={{ fontSize: '2rem', fontWeight: 'bold', color: '#333' }}>
                                    Download Our App
                                </h2>
                                <p className="description mb-4 text-center" style={{ fontSize: '1.1rem', color: '#666', lineHeight: '1.6' }}>
                                    Explore unique handmade artworks created by talented students across India.
                                    Shop meaningful gifts, support young creators, and be part of a creative community — all from your mobile.
                                </p>
                                <div className="app-buttons d-flex flex-wrap justify-content-center gap-3">
                                    <a
                                        href={playStoreLink}
                                        onClick={(e) => handleStoreClick(e, 'playstore')}
                                        className="store-btn"
                                        style={{ display: 'inline-block', transition: 'transform 0.3s ease', cursor: 'pointer' }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        <img
                                            src={playStoreImage}
                                            alt="Get it on Google Play"
                                            style={{ height: '45px', width: 'auto', margin: "0 auto" }}
                                        />
                                    </a>
                                    <a
                                        href={appStoreLink}
                                        onClick={(e) => handleStoreClick(e, 'appstore')}
                                        className="store-btn"
                                        style={{ display: 'inline-block', transition: 'transform 0.3s ease', cursor: 'pointer' }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        <img
                                            src={appStoreImage}
                                            alt="Download on the App Store"
                                            style={{ height: '45px', width: 'auto' }}
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <style jsx>{`
                    @media (max-width: 768px) {
                        .app-content {
                            text-align: center;
                        }
                        .app-buttons {
                            justify-content: center;
                        }
                        .title {
                            font-size: 1.8rem !important;
                        }
                        .description {
                            font-size: 1rem !important;
                        }
                        .store-btn img {
                            height: 50px !important;
                        }
                    }
                    @media (max-width: 576px) {
                        .title {
                            font-size: 1.5rem !important;
                        }
                        .store-btn img {
                            height: 45px !important;
                        }
                    }
                `}</style>
            </section>

            {/* Modal */}
            {modalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <button className="modal-close" style={{ zIndex: "999" }} onClick={closeModal}>×</button>
                        </div>

                        {!submitted ? (
                            <>
                                <div className="modal-icon">
                                    🎨
                                </div>
                                <h3 className="modal-title">Coming Very Soon!</h3>
                                <p className="modal-description">
                                    We're working hard to bring you an amazing experience.
                                    Be the first to know when our app launches!
                                </p>

                                <form onSubmit={handleSubmit} className="modal-form">
                                    <div className="input-group">
                                        <input
                                            type="tel"
                                            className="mobile-input"
                                            placeholder="Enter your mobile number"
                                            value={mobileNumber}
                                            onChange={(e) => setMobileNumber(e.target.value)}
                                            maxLength="10"
                                            pattern="[0-9]{10}"
                                            required
                                        />
                                        <button
                                            type="submit"
                                            className="submit-btn"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Notifying...' : 'Notify Me'}
                                        </button>
                                    </div>
                                    <p className="privacy-note">
                                        We'll notify you when the app is live.
                                    </p>
                                </form>
                            </>
                        ) : (
                            <div className="success-message">
                                <div className="success-icon">✓</div>
                                <h3 className="success-title">Thank You!</h3>
                                <p className="success-description">
                                    We'll notify you as soon as the app is live. Get ready for an amazing art journey!
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <style jsx>{`
                /* Modal Overlay */
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.85);
                    backdrop-filter: blur(8px);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999;
                    animation: fadeIn 0.3s ease;
                }

                /* Modal Container */
                .modal-container {
                    background: linear-gradient(135deg, #fff 0%, #fef9f0 100%);
                    border-radius: 24px;
                    max-width: 500px;
                    width: 90%;
                    margin: 20px;
                    padding: 40px 30px;
                    position: relative;
                    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
                    animation: slideUp 0.3s ease;
                    border: 1px solid rgba(123, 63, 140, 0.2);
                }

                /* Modal Header */
                .modal-header {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    border:none;
                }

                .modal-close {
                    background: none;
                    border: none;
                    font-size: 32px;
                    cursor: pointer;
                    color: #999;
                    transition: all 0.3s ease;
                    width: 36px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                }

                .modal-close:hover {
                    color: #7B3F8C;
                    background: rgba(123, 63, 140, 0.1);
                    transform: rotate(90deg);
                }

                /* Modal Icon */
                .modal-icon {
                    font-size: 64px;
                    text-align: center;
                    margin-bottom: 20px;
                    animation: bounce 1s ease infinite;
                }

                /* Modal Title */
                .modal-title {
                    font-size: 28px;
                    font-weight: bold;
                    text-align: center;
                    color: #7B3F8C;
                    margin-bottom: 12px;
                    background: linear-gradient(135deg, #7B3F8C, #A86BBF);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }

                /* Modal Description */
                .modal-description {
                    text-align: center;
                    color: #666;
                    line-height: 1.6;
                    margin-bottom: 30px;
                    font-size: 16px;
                }

                /* Form Styles */
                .modal-form {
                    margin-top: 10px;
                }

                .modal-form .input-group {s
                    display: flex;
                    gap: 12px;
                    margin-bottom: 16px;
                    flex-wrap: wrap;
                }

                .mobile-input {
                    flex: 1;
                    padding: 14px 18px;
                    border: 2px solid #e0e0e0;
                    border-radius: 12px;
                    font-size: 16px;
                    transition: all 0.3s ease;
                    outline: none;
                    font-family: inherit;
                }

                .mobile-input:focus {
                    border-color: #7B3F8C;
                    box-shadow: 0 0 0 3px rgba(123, 63, 140, 0.1);
                }

                .submit-btn {
                    background: linear-gradient(135deg, #7B3F8C, #A86BBF);
                    color: white;
                    border: none;
                    padding: 14px 28px;
                    border-radius: 12px;
                    font-size: 16px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    white-space: nowrap;
                }

                .submit-btn:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(123, 63, 140, 0.3);
                }

                .submit-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .privacy-note {
                    font-size: 12px;
                    color: #999;
                    text-align: center;
                    margin-top: 16px;
                }

                /* Success Message */
                .success-message {
                    text-align: center;
                    animation: fadeIn 0.5s ease;
                }

                .success-icon {
                    width: 70px;
                    height: 70px;
                    background: linear-gradient(135deg, #4caf50, #45a049);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 20px;
                    font-size: 36px;
                    color: white;
                    animation: scaleUp 0.5s ease;
                }

                .success-title {
                    font-size: 24px;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 12px;
                }

                .success-description {
                    color: #666;
                    line-height: 1.6;
                    font-size: 16px;
                }

                /* Animations */
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                @keyframes slideUp {
                    from {
                        transform: translateY(50px);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }

                @keyframes bounce {
                    0%, 100% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-10px);
                    }
                }

                @keyframes scaleUp {
                    from {
                        transform: scale(0);
                    }
                    to {
                        transform: scale(1);
                    }
                }

                /* Responsive Design */
                @media (max-width: 768px) {
                    .modal-container {
                        padding: 30px 20px;
                        max-width: 450px;
                    }

                    .modal-title {
                        font-size: 24px;
                    }

                    .modal-description {
                        font-size: 14px;
                    }

                    .modal-form .input-group {
                        flex-direction: column;
                    }

                    .submit-btn {
                        width: 100%;
                    }

                    .mobile-input {
                        width: 100%;
                    }
                }

                @media (max-width: 480px) {
                    .modal-container {
                        padding: 25px 20px;
                        width: 95%;
                    }

                    .modal-title {
                        font-size: 22px;
                    }

                    .modal-icon {
                        font-size: 48px;
                    }

                    .modal-close {
                        top: 15px;
                        right: 15px;
                    }
                }
            `}</style>
        </>
    );
}

export default DownloadApp;
